import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { _longPressDisplayTypes, _longPressTypes, LongPressWrapper, LPW } from 'global/wrappers/LongPressWrapper';
import React, { useContext, useEffect, useState } from 'react';
import { Dropdown, Icon, Image, Label, Menu } from 'semantic-ui-react';
import { getAuthHeaderProps } from '../auth/authSettings';
import { FrameworkContext } from '../cnr/contexts/FrameworkContent';
import { HeaderContext } from '../cnr/contexts/HeaderContext';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { uniqueKey } from '../common/keys';
import AppUserPages from '../components/user/AppUserPages';
import AppUserSettings from '../components/user/AppUserSettings';
import { appFormTypes } from '../enums/appFormTypes';
import { appIconTypes } from '../enums/appIconTypes';
import { appUserDropdownItems } from './AppUserItems';
import SearchPage from './SearchPage';

/**
 * 
 * @returns a Menu.Item
 */
const TopMenuIcons = () => {

  const parentContext = useContext(ParentContext);
  const { states, handlers, fns } = parentContext ?? {}
  const { appUser_state, paps_state, currentSettings_state } = states
  const { appUser_handlers } = handlers ?? {}
  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { navigation_fns } = fns

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { fw_info } = framework_state ?? {}
  const { handleClick_contentItem } = framework_handlers ?? {}

  // appUser 
  let { appUser, notificationRequestGranted } = appUser_state ?? {}
  const appUserAccess = useAppUserAccess()
  let { loggedIn, appUserSessionKey, isAdminOrSuper } = appUserAccess ?? {}

  // papsContext 
  const { view, landingView, pathViews, messagingSupported } = paps_state

  // pageContext 
  const { topMenu } = aps_global ?? {}
  const { menuLocation } = topMenu ?? {}
  const { myProfileCaption, myProfileIcon, showProfileAvatar, appUserCollection, showHeaderDropdown } = aps_appUserSettings ?? {}

  // headerContext
  const headerContext = useContext(HeaderContext)
  const { header_state } = headerContext ?? {} // yes, this is true
  const { allowSiteSearch } = header_state ? header_state : {}

  const _allowSiteSearch = allowSiteSearch && fw_info ? true : false

  const [authProps, setAuthProps] = useState()
  const [showTopMenuSearch, setShowTopMenuSearch] = useState()
  const [showAppUserSettings, setShowAppUserSettings] = useState()
  const [showSettings, setShowSettings] = useState();

  const upward = menuLocation === 'bottom' && view === landingView ? true : false

  // get the time form
  useEffect(() => {
    const _authProps = getAuthHeaderProps({ appUserAccess, aps_global, notificationRequestGranted, messagingSupported })
    setAuthProps(_authProps)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [appUserAccess, notificationRequestGranted]);

  const handleShowSearch = () => setShowTopMenuSearch(!showTopMenuSearch)
  const handleMenuClick = (dropItem, itemKey) => navigation_fns.handleNav_item({ key: dropItem }, itemKey)
  const handleShowSettings = () => setShowSettings(!showSettings)
  const handleShowAppUserSettings = () => setShowAppUserSettings(!showAppUserSettings)
  const handleIconClick = () => handleClick_contentItem({ key: appUserCollection, itemKey: appUserSessionKey }, appUserSessionKey)

  const handleHomeClick = () => {
    if (pathViews.events) {
      navigation_fns.handleNav_item({ key: landingView })
    }
  }

  const handleResetAccessLevel = (e) => {
    e.stopPropagation()
    appUser_handlers.handleResetAccessLevel()
  }

  const iSearch = () => <Menu.Item onClick={() => { handleShowSearch() }}>
    <Icon name={appIconTypes.search} style={{ color: 'var(--off-white-3)', marginRight: '1em' }}></Icon>
  </Menu.Item>

  const icon_user = (iconName, value, cn) => <Icon
    name={iconName}
    className={cn ? cn : null}
  >
    {value ? value : null}
  </Icon>

  const userLabel = (iconName, value, cn) => {
    let cnn = 'lbl-user'
    return <LPW longPressType={_longPressTypes.appUser} longPressDisplayType={_longPressDisplayTypes.full}>
      <Label color={authProps.color} className={cnn} onClick={() => { !isAdminOrSuper && handleIconClick() }}>
        {icon_user(iconName, value, cn)}
        <Icon name={authProps.iconBell} color={authProps.nrg ? 'black' : 'grey'} />
      </Label>
    </LPW>
  }

  const menuIcon = (iconName, value, cn) => <Menu.Item>
    {userLabel(iconName, value, cn)}
  </Menu.Item>

  /** Creates an `Icon` that will trigger the `menu dropdown`.
* @returns Icon
*/
  const iTrigger = () => {
    if (authProps) {
      if (authProps.value) {
        if (showProfileAvatar && appUserAccess && appUser.imageUrls && appUser.imageUrls.thumbnail) {
          return <Image src={appUser.imageUrls.thumbnail} avatar></Image>
        } else {
          let cn = 'icon-text'
          return showHeaderDropdown ? icon_user(authProps.name, authProps.value, 'icon-text') : menuIcon(authProps.name, authProps.value, cn)
        }
      } else {
        return showHeaderDropdown ? icon_user(appIconTypes.user) : menuIcon(appIconTypes.user)
      }
    }
  }



  const menuRight = () => {
    const icon = !appUser && appIconTypes.ellipsisVertical
    const trigger = iTrigger()

    if (showHeaderDropdown) {
      return <React.Fragment>
        {_allowSiteSearch && iSearch()}
        {trigger}
        <Dropdown item icon={icon} trigger={trigger} upward={upward} >
          <Dropdown.Menu className={'menu-drop-right'} size='tiny'  >
            <Dropdown.Item key={uniqueKey('tmi', 'di', 'home')} icon='home' text='Home' onClick={() => { handleHomeClick() }} />
            {loggedIn && appUserDropdownItems({ appUserAccess, myProfileCaption, myProfileIcon, loggedIn, pathViews, appUserCollection, handleMenuClick, handleShowSettings })}
          </Dropdown.Menu>
        </Dropdown>
      </React.Fragment>
    } else {
      return <React.Fragment>
        {_allowSiteSearch && iSearch()}
        {trigger}
      </React.Fragment>
    }

  }

  if (showSettings) {
    return <AppUserPages
      appFormType={appFormTypes.appAuth}
      useFullPageWrapper={true}
      handleCancel={handleShowSettings}
    />
  } else if (showAppUserSettings) {
    return <AppUserSettings
      handleCancel={handleShowAppUserSettings}
    />
  } else {
    return showTopMenuSearch ? <SearchPage handleShowSearch={handleShowSearch} /> : menuRight()
  }
}

export default TopMenuIcons